import React, { useState } from 'react';
import { MessageCircle, Youtube, Instagram, X, FileText, ExternalLink, Sparkles, ArrowRight, Heart } from 'lucide-react';

// Модальное окно для оферты
const OfertaModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/95 backdrop-blur-sm" onClick={onClose}>
      <div className="relative bg-gradient-to-b from-zinc-900 to-zinc-950 rounded-3xl max-w-3xl max-h-[90vh] overflow-auto border border-zinc-700/50" onClick={e => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 w-12 h-12 rounded-full bg-zinc-800 border border-zinc-700 flex items-center justify-center text-white hover:bg-zinc-700 transition-colors z-10">
          <X className="w-5 h-5" />
        </button>
        
        <div className="p-8 sm:p-10">
          <h2 className="text-2xl sm:text-3xl font-black text-white mb-8">Договор оферты</h2>
          
          <div className="prose prose-invert prose-sm max-w-none text-zinc-400 space-y-4">
            <p className="text-amber-400 font-semibold text-lg">Публичная оферта на оказание услуг по обучению</p>
            
            <p>Настоящий документ является официальным предложением (публичной офертой) индивидуального предпринимателя Малюк Вадим (далее – «Исполнитель») заключить договор на нижеследующих условиях о предоставлении услуг по обучению (далее – «Услуги») в соответствии с законодательством Украины.</p>
            
            <p><strong className="text-white">Дата публикации оферты:</strong> 19.02.2024</p>
            
            <h3 className="text-white text-lg font-bold mt-6">1. Общие положения</h3>
            <p>1.1. Настоящий Договор является публичной офертой в соответствии с законодательством Украины.</p>
            <p>1.2. Договор вступает в силу с момента акцепта условий настоящей оферты Пользователем.</p>
            <p>1.3. Исполнитель оставляет за собой право вносить изменения в условия настоящей оферты.</p>
            
            <h3 className="text-white text-lg font-bold mt-6">2. Предмет договора</h3>
            <p>2.1. Исполнитель обязуется предоставить Пользователю услуги по обучению в форме онлайн-курсов.</p>
            <p>2.2. Перечень тем, содержание курса устанавливаются на сайте Исполнителя.</p>
            
            <h3 className="text-white text-lg font-bold mt-6">3. Порядок оказания услуг</h3>
            <p>3.1. Доступ к обучающим материалам предоставляется после полной оплаты.</p>
            <p>3.2. Услуги оказываются в режиме онлайн посредством предоставления доступа к видеоматериалам.</p>
            <p>3.3. При необходимости могут проводиться групповые или индивидуальные консультации.</p>
            
            <h3 className="text-white text-lg font-bold mt-6">4. Права и обязанности сторон</h3>
            <p>4.1. Исполнитель обязуется предоставить доступ к обучающим материалам и обеспечить поддержку.</p>
            <p>4.2. Пользователь обязуется использовать материалы исключительно в личных, некоммерческих целях.</p>
            
            <h3 className="text-white text-lg font-bold mt-6">5. Стоимость услуг и порядок расчетов</h3>
            <p>5.1. Стоимость услуг устанавливается на сайте Исполнителя.</p>
            <p>5.2. Оплата производится посредством безналичного расчёта.</p>
            
            <h3 className="text-white text-lg font-bold mt-6">6. Ответственность сторон</h3>
            <p>6.1. Стороны несут ответственность за неисполнение обязательств в соответствии с законодательством Украины.</p>
            <p>6.2. Исполнитель не несёт ответственности за технические неполадки, не зависящие от него.</p>
            
            <h3 className="text-white text-lg font-bold mt-6">7. Форс-мажор</h3>
            <p>7.1. Стороны не несут ответственности за неисполнение обязательств вследствие обстоятельств непреодолимой силы.</p>
            
            <h3 className="text-white text-lg font-bold mt-6">8. Разрешение споров</h3>
            <p>8.1. Все споры решаются путем переговоров между Сторонами.</p>
            <p>8.2. При невозможности достижения соглашения спор передаётся в суд по месту нахождения Исполнителя.</p>
            
            <h3 className="text-white text-lg font-bold mt-6">9. Заключительные положения</h3>
            <p>9.1. Настоящий Договор является публичной офертой и действует для всех Пользователей.</p>
            <p>9.2. Стороны руководствуются действующим законодательством Украины.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const Footer = () => {
  const [showOferta, setShowOferta] = useState(false);

  return (
    <footer className="relative bg-[#030304] border-t border-zinc-800/50 overflow-hidden">
      <OfertaModal isOpen={showOferta} onClose={() => setShowOferta(false)} />
      
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-[400px] h-[400px] bg-amber-500/[0.02] rounded-full blur-[150px]" />
        <div className="absolute bottom-0 right-1/4 w-[300px] h-[300px] bg-violet-500/[0.02] rounded-full blur-[100px]" />
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-16 sm:py-20">
        {/* Top CTA Section */}
        <div className="relative mb-16 sm:mb-20">
          <div className="absolute -inset-4 bg-gradient-to-r from-amber-500/10 via-orange-500/15 to-amber-500/10 rounded-[2rem] blur-2xl" />
          
          <div className="relative bg-gradient-to-b from-zinc-800/80 to-zinc-900/80 backdrop-blur-xl rounded-3xl p-8 sm:p-10 lg:p-12 border border-amber-500/20">
            <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
              <div className="text-center lg:text-left">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-500/10 border border-amber-500/30 mb-4">
                  <Sparkles className="w-4 h-4 text-amber-400" />
                  <span className="text-amber-300 font-semibold text-sm">Готовы начать?</span>
                </div>
                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-black text-white mb-3">
                  Постройте стабильный бизнес на Amazon
                </h3>
                <p className="text-zinc-400 text-base sm:text-lg max-w-xl">
                  Присоединяйтесь к 100+ ученикам, которые уже зарабатывают на Amazon
                </p>
              </div>
              
              <a 
                href="#pricing"
                className="group relative inline-flex items-center gap-3 px-10 py-5 bg-gradient-to-r from-amber-500 via-orange-500 to-amber-500 bg-[length:200%_100%] animate-gradient text-black font-black text-lg rounded-2xl shadow-2xl hover:shadow-amber-500/40 hover:-translate-y-1 transition-all duration-300 flex-shrink-0"
              >
                <span className="relative z-10">Начать обучение</span>
                <ArrowRight className="w-5 h-5 relative z-10 group-hover:translate-x-1 transition-transform" />
                
                {/* Shine Effect */}
                <div className="absolute inset-0 rounded-2xl overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" />
                </div>
              </a>
            </div>
          </div>
        </div>

        {/* Main Footer Content */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Logo & Company */}
          <div>
            <div className="flex items-center gap-4 mb-6">
              <div className="relative">
                <div className="absolute -inset-1 bg-gradient-to-r from-amber-500 to-orange-500 rounded-xl blur opacity-40" />
                <div className="relative w-12 h-12 rounded-xl bg-gradient-to-br from-amber-500 to-orange-500 flex items-center justify-center shadow-xl">
                  <span className="text-black font-black text-xl">A</span>
                </div>
              </div>
              <div>
                <p className="text-white font-bold text-lg">Amazon Wholesale</p>
                <p className="text-zinc-500 text-sm">by Малюк Вадим</p>
              </div>
            </div>
            <p className="text-zinc-400 text-base mb-3">Курс по заработку на Amazon для новичков</p>
            <p className="text-zinc-600 text-sm">Bustim LLC</p>
          </div>
          
          {/* Navigation */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Навигация</h4>
            <ul className="space-y-3">
              {[
                { href: '#about', label: 'Об авторе' },
                { href: '#what-inside', label: 'Что внутри' },
                { href: '#modules', label: 'Программа курса' },
                { href: '#results', label: 'Результаты' },
                { href: '#pricing', label: 'Тарифы' },
                { href: '#faq', label: 'FAQ' },
              ].map((link, i) => (
                <li key={i}>
                  <a href={link.href} className="text-zinc-400 hover:text-amber-400 text-base transition-colors duration-300 flex items-center gap-2 group">
                    <span className="w-1.5 h-1.5 rounded-full bg-zinc-700 group-hover:bg-amber-500 transition-colors" />
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Social */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Соцсети</h4>
            <div className="space-y-4">
              {[
                { href: 'https://t.me/vadjikamazon', icon: MessageCircle, label: 'Telegram канал', gradient: 'from-blue-500 to-blue-600', glow: 'shadow-blue-500/30' },
                { href: 'https://www.youtube.com/@vadym_ecommerce', icon: Youtube, label: 'YouTube', gradient: 'from-red-500 to-red-600', glow: 'shadow-red-500/30' },
                { href: 'https://www.instagram.com/vadym_ecommerce/', icon: Instagram, label: 'Instagram', gradient: 'from-pink-500 via-purple-500 to-orange-400', glow: 'shadow-pink-500/30' },
              ].map((social, i) => (
                <a key={i} href={social.href} target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 text-zinc-300 hover:text-white transition-colors group">
                  <div className={`w-11 h-11 rounded-xl bg-gradient-to-br ${social.gradient} flex items-center justify-center text-white group-hover:scale-110 transition-transform shadow-xl ${social.glow}`}>
                    <social.icon className="w-5 h-5" />
                  </div>
                  <span className="text-base font-medium">{social.label}</span>
                </a>
              ))}
            </div>
          </div>
          
          {/* Contact */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Связь</h4>
            <a 
              href="https://t.me/vadjik" 
              target="_blank" 
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-3 px-6 py-4 bg-gradient-to-r from-amber-500 to-orange-500 text-black font-bold rounded-xl hover:shadow-xl hover:shadow-amber-500/30 transition-all hover:-translate-y-0.5"
            >
              <MessageCircle className="w-5 h-5" />
              <span>Написать Вадиму</span>
            </a>
            <p className="text-zinc-500 text-sm mt-4">Отвечаем в течение 24 часов</p>
          </div>
        </div>
        
        {/* Divider */}
        <div className="section-divider mb-8" />
        
        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2 text-zinc-600 text-sm">
            <span>© 2025 Bustim LLC.</span>
            <span className="hidden sm:inline">•</span>
            <span className="hidden sm:inline">Made with</span>
            <Heart className="w-4 h-4 text-red-500 hidden sm:inline" />
          </div>
          
          <div className="flex items-center gap-6">
            <button 
              onClick={() => setShowOferta(true)}
              className="text-zinc-500 hover:text-amber-400 text-sm transition-colors flex items-center gap-2 group"
            >
              <FileText className="w-4 h-4 group-hover:scale-110 transition-transform" />
              <span>Договор оферты</span>
            </button>
            <p className="text-zinc-600 text-sm hidden md:block">Результаты зависят от рынка, капитала и действий</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
